import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import LocaleContext from 'constants/localization';

import Header from 'field/common/Header';
import Form from 'react-bootstrap/Form';
import Required from 'field/common/Required';
import CreateResourceButton from 'field/edit/resource/CreateResourceButton';
import EditLinkedResources from 'field/edit/resource/EditLinkedResources';
import ResourceSearch from 'field/edit/resource/ResourceSearch';

// Default Component for field when no custom implementation exists for
// type parameter (or when type is rdf:Resource)
const UserEdit = props => {
  const LS = useContext(LocaleContext);
  const { field, children } = props;
  const valueCount = field.values.filter(Boolean).length;
  const disabled = field.values.length >= field.props.maxOccurs;

  const onRemove = (index, value) => {
    if (confirm(LS.prompt.removeObject)) {
      field.removeResource(index, value);
    }
  }

  return (
    <Form.Group className="field resource">
      <Header field={field} />
      <ResourceSearch {...props} />
      <EditLinkedResources 
        onRemove={props.onRemove || onRemove}
        values={field.values} />
      <Required minOccurs={field.props.minOccurs} valueCount={valueCount} />
      { children }
    </Form.Group>
  );
};

UserEdit.propTypes = {
  field: PropTypes.object.isRequired,
};

export default UserEdit;